import type { ActivityFeedQuoteOrderPayload } from '../../../server/types/customer-activity-feed-types.ts';
import type { ActivityFeedQuoteOrderItemPayload } from '../components/activity-feed-quote-order-item.tsx';

/** A visit's linked quote comes as a list row, whose nullable columns the card does not accept. */
export function toQuoteOrderItemPayload(
    quote: ActivityFeedQuoteOrderPayload,
): ActivityFeedQuoteOrderItemPayload {
    return {
        sales_order_id: quote.sales_order_id,
        display_id: quote.display_id ?? '',
        status: quote.status,
        total_amount_net: quote.total_amount_net ?? 0,
        total_margin: quote.total_margin ?? 0,
        line_items_count: Number(quote.line_items_count),
        po_number: quote.po_number ?? '',
        clerk_name: quote.clerk_name ?? undefined,
        entry_date: quote.entry_date,
        customer_id: quote.customer_id,
        customer_name: quote.customer_name,
    };
}
